import {Buffer} from 'buffer';

import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import {applyWorktreeOverrideFromUrl} from '@dms/config';
import '@dms/i18n';
import {redirectToLogin} from '@dms/routes';

import {App} from './App';

// Polyfill Buffer for Apollo Client
window.Buffer = Buffer;

// Local dev: `?x-worktree=<name>` repoints every API request at a backend worktree. Switching
// targets invalidates the session (refresh tokens are per-worktree), so log in again first.
if (applyWorktreeOverrideFromUrl()) {
  redirectToLogin();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
